import { render, staticRenderFns } from "./PermanentRegistrationContainer.vue?vue&type=template&id=79707d87&scoped=true&lang=html&"
import script from "./PermanentRegistrationContainer.vue?vue&type=script&lang=js&"
export * from "./PermanentRegistrationContainer.vue?vue&type=script&lang=js&"
import style0 from "./PermanentRegistrationContainer.vue?vue&type=style&index=0&id=79707d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79707d87",
  null
  
)

export default component.exports